import * as dataAccess from 'app/utils/ajax';

export const fetchData = async (path, params) => {
  const queryParams = [];

  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ''
    ) {
      queryParams.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  });

  const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
  const url = `${path}${queryString}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const postData = async (path, params, payload) => {
  const queryParams = [];

  Object.keys(params).forEach((key) => {
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ''
    ) {
      queryParams.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  });

  const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
  const url = `${path}${queryString}`;
  let responseObj = await dataAccess.post(url, payload);
  return responseObj;
};
